import { isTest } from './env';
var eventMap = {};
var documentRef;

try {
  documentRef = isTest() ? {
    addEventListener: jest.fn(function (eventName, cb) {
      eventMap[eventName] = cb;
    }),
    removeEventListener: jest.fn(function (eventName) {
      delete eventMap[eventName];
    }),
    dispatchEvent: jest.fn(function (event) {
      eventMap[event.type](event);
    })
  } : document;
} catch (e) {
  documentRef = {
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    dispatchEvent: function dispatchEvent() {
      return true;
    }
  };
}

var createMockEvent = function createMockEvent(event) {
  switch (event.type) {
    case 'keyup':
    case 'keydown':
    case 'keypress':
      return new KeyboardEvent(event.type, {
        key: event.key
      });

    case 'mouseover':
    case 'mousedown':
    case 'mouseup':
      return new MouseEvent(event.type, {
        relatedTarget: event.target
      });

    default:
      return new Event(event.type);
  }
};

export { createMockEvent };
export default (function () {
  return documentRef;
});